import * as React from "react";

import Router from "./components/Layout/Router";
import SessionStore from "./stores/sessionStore";
import SignalRAspNetCoreHelper from "./lib/signalRAspNetCoreHelper";
import Stores from "./stores/storeIdentifier";
import { inject } from "mobx-react";
import TimeAgo from 'javascript-time-ago'
import withSplashScreen from "@components/Layout/SplashScreen";

import AppConsts from "@lib/appconst";
import { isMobile } from "react-device-detect";

import en from 'javascript-time-ago/locale/en'
TimeAgo.addDefaultLocale(en)

const { authorization } = AppConsts;

export interface IAppProps {
  sessionStore?: SessionStore;
}

@inject(Stores.SessionStore)
class App extends React.Component<IAppProps> {
  state = { isLoading: true };

  async componentDidMount() {
    if (isMobile) {
      const root: any = document.getElementById('root')
      if (root) {
        root.style.maxHeight = `${window.innerHeight}px`;
      }
    }

    await this.props.sessionStore!.getCurrentLoginInformations();

    if (
      !!this.props.sessionStore!.currentLogin.user &&
      this.props.sessionStore!.currentLogin.application.features["SignalR"]
    ) {
      SignalRAspNetCoreHelper.initSignalR();
    }

    if (
      !!this.props.sessionStore!.currentLogin.user &&
      localStorage.getItem(authorization.projectId)
    ) {
      await Promise.all([
        this.props.sessionStore?.getMyProfilePicture(),
        this.props.sessionStore!.getOwnProjects({}),
      ]);
    }

    // this.setState({ isLoading: false });
  }

  componentWillUnmount() { }

  public render() {
    // if (this.state.isLoading) return null;

    return <Router />
  }
}

export default withSplashScreen(App);
